import { atom } from "jotai";
import { atomWithStorage } from "jotai/utils";

export const drawingTool = atom({
  active: false,
});

export const currentPageState = atom("main");

export const drawing = atomWithStorage("bookdraw", []);
export const videoState = atom(true);
export const colorPickerState = atom(false);

export const correctSound = require("@assets/sounds/effects/correct.mp3");
export const incorrectSound = require("@assets/sounds/effects/incorrect.mp3");
export const clickSound = require("@assets/sounds/effects/bbok.mp3");
export const flipSound = require("@assets/sounds/effects/flip.mp3");
export const cardFlipSound = require("@assets/sounds/effects/card_flip.mp3");
export const popupSound = require("@assets/sounds/effects/popin.mp3");
export const swapSound = require("@assets/sounds/effects/swap.mp3");
export const touchSound = require("@assets/sounds/effects/touch.mp3");
export const clearSound = require("@assets/sounds/effects/clear.mp3");

export const sleep = (ms) => {
  return new Promise((r) => setTimeout(r, ms));
};

export const shuffle = (array) =>
  array.concat().sort(() => Math.random() - 0.5);

let body = null;
export const blockTouch = (isBlock = true) => {
  if (body === null) {
    body = document.body;
  }
  if (isBlock) {
    body.classList.add("block-stage");
  } else {
    body.classList.remove("block-stage");
  }
};

// loading
export const loading = (isLoading = true) => {
  if (body === null) {
    body = document.body;
  }
  if (isLoading) {
    body.classList.add("loading");
  } else {
    body.classList.remove("loading");
  }
};

export const randomSort = (array) => {
  return array.sort(() => Math.random() - 0.5);
};

export const randomRange = (start, end) => {
  return Math.floor(Math.random() * (end - start + 1) + start);
};

export const getWord = (word, categoryKey) => {
  const wordSplit = word.split("|");
  if (wordSplit.length === 1) {
    return wordSplit[0];
  } else {
    // word 데이터는 병음|한자 형식으로 셋팅된다.
    if (categoryKey === "c1" || categoryKey === "c2" || categoryKey === "c3") {
      // 빨강, 주황, 노랑 까지는 병음으로
      return wordSplit[1];
    } else {
      // 나머지는 한자로
      return wordSplit[0];
    }
  }
};
